const defaultContext = ['mainCookie', 'abTests'];
const trackers = {
  structured: 'trackStructEvent',
  selfDescribing: 'trackSelfDescribingEvent',
};

export const climatePledgeInfoboxDisplay = {
  tracker: trackers.structured,
  data: {
    category: 'climate_pledge_entity',
    action: 'display',
    label: 'serp_page',
    property: '',
    value: '0',
  },
  context: defaultContext,
};

export const climatePledgeInfoboxRatingClick = {
  tracker: trackers.structured,
  data: {
    category: 'climate_pledge_entity',
    action: 'click',
    label: 'rating',
    property: '',
    value: '0',
  },
  context: defaultContext,
};

export const climatePledgeInfoboxShowDetailsClick = {
  tracker: trackers.structured,
  data: {
    category: 'climate_pledge_entity',
    action: 'click',
    label: 'show_details',
    property: '',
    value: '0',
  },
  context: defaultContext,
};

export const climatePledgeInfoboxHideDetailsClick = {
  tracker: trackers.structured,
  data: {
    category: 'climate_pledge_entity',
    action: 'click',
    label: 'hide_details',
    property: '',
    value: '0',
  },
  context: defaultContext,
};

export const climatePledgeInfoboxSeeMeaningClick = {
  tracker: trackers.structured,
  data: {
    category: 'climate_pledge_entity',
    action: 'click',
    label: 'see_meaning',
    property: '',
    value: '0',
  },
  context: defaultContext,
};

export const climatePledgeInfoboxSourcesClick = (property = '') => ({
  tracker: trackers.structured,
  data: {
    category: 'climate_pledge_entity',
    action: 'click',
    label: 'sources',
    property,
    value: '0',
  },
  context: defaultContext,
});

export const climatePledgeOverlayDisplay = (property = '') => ({
  tracker: trackers.structured,
  data: {
    category: 'climate_pledge_overlay',
    action: 'display',
    label: 'serp_page',
    property,
    value: '0',
  },
  context: defaultContext,
});

export const climatePledgeOverlaySourceClick = (property = '') => ({
  tracker: trackers.structured,
  data: {
    category: 'climate_pledge_overlay',
    action: 'click',
    label: 'sources',
    property,
    value: '0',
  },
  context: defaultContext,
});

export const climatePledgeOverlayFaqClick = {
  tracker: trackers.structured,
  data: {
    category: 'climate_pledge_overlay',
    action: 'click',
    label: 'faq',
    property: '',
    value: '0',
  },
  context: defaultContext,
};

export const climatePledgeTooltipDisplay = {
  tracker: trackers.structured,
  data: {
    category: 'climate_pledge_rich',
    action: 'display',
    label: 'serp_page',
    property: '',
    value: '0',
  },
  context: defaultContext,
};

export const climatePledgeTooltipSeeMeaningClick = {
  tracker: trackers.structured,
  data: {
    category: 'climate_pledge_rich',
    action: 'click',
    label: 'see_meaning',
    property: '',
    value: '0',
  },
  context: defaultContext,
};

export const climatePledgeRatingImpression = (data = {}) => ({
  tracker: trackers.selfDescribing,
  data: {
    schema: 'iglu:org.ecosia/result_impression_event/jsonschema/1-0-2',
    data: {
      result_label: 'climate_pledge',
      result_type: 'organic',
      vertical: 'web',
      page_position: 'mainline',
      ...data,
    },
  },
  context: defaultContext,
});
